import { RichText } from '@/components/shared/rich-text'
import { RichtextStoryblok } from '@/lib/types/component-types-sb'
import { cn } from '@/lib/utils'
import { DynamicIcon } from 'lucide-react/dynamic'

type SectionHeaderProps = {
  title?: string
  icon?: string
  preTitle?: string
  content?: RichtextStoryblok
  titleTag?: 'h1' | 'h2' | 'h3'
  /**
   * @deprecated use `layout` property
   */
  center?: boolean
  layout?: 'default' | 'stacked' | 'center'
}

export function SectionHeader({
  title,
  icon,
  preTitle,
  content,
  titleTag = 'h2',
  center = false,
  layout = 'default',
}: SectionHeaderProps) {
  const Heading = titleTag

  if (center) {
    layout = 'center'
  }

  return (
    <div
      className={cn({
        'flex flex-col': true,
        'justify-between lg:flex-row lg:items-end': layout === 'default',
        'items-center gap-2.5 text-center lg:flex-col': layout === 'center',
        'gap-2.5': layout === 'stacked',
      })}
    >
      <div
        className={cn({
          'flex flex-col items-start gap-2.5 lg:max-w-[800px]': true,
          'items-center text-center': layout === 'center',
        })}
      >
        {icon && preTitle && (
          <div className="flex items-center gap-2.5 text-sm lg:text-base">
            <DynamicIcon
              name={icon as any}
              strokeWidth={1.5}
              className="text-brand h-5 w-5"
            />
            <span>{preTitle}</span>
          </div>
        )}
        {title && (
          <Heading className="text-accent-foreground text-3xl font-semibold">{title}</Heading>
        )}
      </div>
      {content && (
        <div
          className={cn({
            'lg:max-w-[400px]': layout === 'default',
            'lg:max-w-[600px]': layout === 'stacked' || layout === 'center',
          })}
        >
          <RichText content={content} />
        </div>
      )}
    </div>
  )
}
